import { AfterViewInit, Component, ElementRef, EventEmitter, Inject, OnInit, Output, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as c3 from 'c3';
const monthnames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

@Component({
  selector: 'app-change-over-popup',
  templateUrl: './change-over-popup.component.html',
  styleUrls: ['./change-over-popup.component.scss']
})
export class ChangeOverPopupComponent implements OnInit, AfterViewInit {

  @ViewChild('barGrapChangeOverhDiv') barGrapChangeOverhDiv: ElementRef;
  @Output() factorySummary = new EventEmitter<any>();
  @Output() currentDate = new EventEmitter<any>();
  @Output() currrentFilter = new EventEmitter<any>();
  public oneDateD: any;
  public monthNameN: any;
  currentEndWeek: any;
  emitDataLst: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    const dateData = this.getLocalStorageData('selectedDATimeFilter');
    this.currentEndWeek = '';
    this.emitDataLst = {
      appliedFilterType: dateData ? dateData.appliedFilterType : '',
      dateObj: new Date(dateData.endOfMonth),
      selectedHr: dateData.selectedHr,
      endWeekFromSelectedDate: dateData.endWeekFromSelectedDate,
      startQuarterMonth: null
    };
    this.oneDateD = this.emitDataLst.dateObj;
    this.monthNameN = this.oneDateD.toLocaleString('en-us', { month: 'short' });
  }
  getLocalStorageData(key: string) {
    return JSON.parse(sessionStorage.getItem(key));
  }


  ngAfterViewInit() {
    setTimeout(() => {
      if (this.data) {
        // this.data.xAxisLabels = ['x'].concat(this.data.xAxisLabels);
        // this.data.formatChangeOverData = ['FormatChangeOver'].concat(this.data.formatChangeOverData);
        // this.data.productChangeOverData = ['ProductChangeOver'].concat(this.data.productChangeOverData);
        // this.data.costPercentageData = ['Cost'].concat(this.data.costPercentageData);
        this.generateChangeOverGraph();
      }
    }, 0);
  }

  generateChangeOverGraph() {
    const thisObj = this;
    c3.generate({
      bindto: this.barGrapChangeOverhDiv ? this.barGrapChangeOverhDiv.nativeElement : null,
      padding: {
        top: 0,
        bottom: 0
      },
      size: {
        height: 400,
        width: 800
      },
      data: {
        x: 'x',
        columns: [
          this.data.xAxisLabels,
          this.data.formatChangeOverData,
          this.data.productChangeOverData,
          this.data.costPercentageData,
        ],
        axes: {
          FormatChangeOver: 'y',
          ProductChangeOver: 'y',
          cost: 'y2'
        },
        types: {
          FormatChangeOver: 'bar',
          ProductChangeOver: 'bar',
          cost: 'line'
        },
        colors: {
          FormatChangeOver: '#32B6E0',
          ProductChangeOver: '#8F82C7',
          cost: '#82C7C2'
        },
        names: {
          FormatChangeOver: 'FormatChangeOver',
          ProductChangeOver: 'ProductChangeOver',
          cost: 'Cost %'
        }
      },
      point: {
        show: false
      },
      tooltip: {
        show: true,
        format: {
          title: (x: number) => (this.emitDataLst &&
            (this.emitDataLst.appliedFilterType === 'quarter' || this.emitDataLst.appliedFilterType === 'year' ||
              this.emitDataLst.appliedFilterType === 'month') ? monthnames[x - 1] : (x + ' ' + this.monthNameN + ')')),
          value: (x: number) => (x / thisObj.data.divisionNumber).toFixed(2) + thisObj.data.signType
        }
      },
      bar: {
        width: 5
      },
      axis: {
        y: {
          label: {
            text: 'Changeover',
            position: 'outer-middle'
          },
          tick: {
            format: ((x) => x / thisObj.data.divisionNumber + thisObj.data.signType)
          }
        },
        y2: {
          label: {
            text: 'Cost %',
            position: 'outer-middle'
          },
          show: true,
          tick: {

            format: (d: any) => d + '%'
          }
        },
        x: {
          label: {
            text: 'Month',
            position: 'outer-center'
          },
          // type: 'category',
          // // tick: {
          // //   rotate: -20,
          // //   multiline: false
          // // },
          // categories: this.data.xAxisLabels

        }

      }
    });
  }

}
